export default class ObjectHelper {
  static methodExists(object, method) {
    return method in object && typeof object[method] === 'function';
  }
}
